/*
 * Where each half of the map is asked for (fleet-api DataStructures/MapSource.go).
 *
 * The three are separate on purpose: a deployment can keep drawing OpenStreetMap and
 * still ask TomTom for the speed limits, which is the pairing that actually matters —
 * the tiles are a picture, the limits are a claim about a road, and the two are worth
 * paying for separately.
 */

/** The base map the tiles are drawn from. */
export enum TileSource {
    OSM    = 'osm',
    TomTom = 'tomtom',
}

/** Who is asked what a place at a coordinate is called. */
export enum PlaceNameSource {
    Nominatim = 'nominatim',
    TomTom    = 'tomtom',
}

/** Where the posted limit a drive is compared against comes from. */
export enum SpeedLimitSource {
    OSM    = 'osm',
    TomTom = 'tomtom',
}
